import TravelerContent from "../types/traveler-type";
import api from "./auth-interceptor";

class TravelerService {
  getTravelers() {
    return api.get<TravelerContent[]>(`travelers/`);
  }

  createTraveler(travelerContent: TravelerContent) {
    return api.post(`travelers/`, travelerContent);
  }

  deleteTraveler(travelerId: string) {
    return api.delete<TravelerContent[]>(`travelers/${travelerId}`);
  }
}

const travelerService = new TravelerService();
export default travelerService;
